import React from 'react';

const RequestCustomizedMaterialsDetails = () => {
    return (
        <div>
            
        </div>
    );
};

export default RequestCustomizedMaterialsDetails;